module.exports = __webpack_public_path__ + "static/img/preview-03.5bf920fc.webp";